// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import Portal from '../../../Portal/Portal'
import { ConfirmationPopup } from '../../../confirmation-popup/confirmationpopup'
import newScreenIcon from '../../../../images/common/new-screen.svg'
import { text } from '../../utils'
import { useProductOrderContext } from '../../context'
import { windowOpenArgs } from '../../../../utils/windowOpenArgs'

type Props = {
  treatErrorMessage: string
  getTreatLink: () => Promise<string>
}

export const Confirmations = ({ treatErrorMessage, getTreatLink }: Props) => {
  const {
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    patientId,
    showDiscardOrdersWarning,
    setCartItems,
    setShowDiscardOrdersWarning,
    setProduct,
    setIsShowing,
    goBack,
    showOrderFailed,
    setShowOrderFailed,
    showOrderCreated,
    setShowOrderCreated,
    showOrderCreatedTreat,
    setShowOrderCreatedTreat,
  } = useProductOrderContext()

  const isTreatError = !!treatErrorMessage

  return (
    <>
      {showDiscardOrdersWarning ? <Portal isInBody={false}>
          <ConfirmationPopup
            primaryBtnAction={() => {
              setCartItems([])
              setShowDiscardOrdersWarning('')
              if (showDiscardOrdersWarning === 'close') {
                // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                setProduct(null)
                setIsShowing(false)
              } else {
                goBack(true)
              }
            }}
            title={text.DISCARD_TITLE}
            msg={text.DISCARD_WARNING}
            primaryBtnText={text.DISCARD_ORDER}
            closeAction={() => {
              setShowDiscardOrdersWarning('')
            }}
            additionalContainerClass='product-order-popup-container'
            secondaryBtnText={text.CLOSE}
            secondaryBtnAction={() => {
              setShowDiscardOrdersWarning('')
            }}
            popUpBoxStyle={{ height: 'unset', marginTop: 0, padding: 64, maxWidth: 589 }}
            renderBody={undefined}
            id={undefined}
            isCancelledStatus={undefined}
            subTitle={undefined}
            useUpdatedStyle
          />
        </Portal> : null}

      {showOrderFailed ? <Portal isInBody={false}>
          <ConfirmationPopup
            primaryBtnAction={() => {
              setShowOrderFailed(false)
            }}
            title={text.ORDER_FAILED}
            msg={text.ORDER_FAILED_MESSAGE}
            primaryBtnText={text.OK}
            closeAction={() => {
              setShowOrderFailed(false)
            }}
            additionalContainerClass='product-order-popup-container'
            secondaryBtnText={undefined}
            secondaryBtnAction={undefined}
            popUpBoxStyle={{ height: 'unset', marginTop: 0, padding: 64, maxWidth: 589 }}
            renderBody={undefined}
            id={undefined}
            isCancelledStatus={undefined}
            subTitle={undefined}
            useUpdatedStyle
          />
        </Portal> : null}

      {showOrderCreated ? <Portal isInBody={false}>
          <ConfirmationPopup
            primaryBtnAction={() => {
              setShowOrderCreated(false)
            }}
            title={text.ORDER_SUCCESSFUL}
            msg={text.ORDER_SUCCESSFUL_MESSAGE}
            primaryBtnText={text.OK}
            closeAction={() => {
              setShowOrderCreated(false)
            }}
            additionalContainerClass='product-order-popup-container'
            secondaryBtnText={undefined}
            secondaryBtnAction={undefined}
            popUpBoxStyle={{ height: 'unset', marginTop: 0, padding: 64, maxWidth: 589 }}
            renderBody={undefined}
            id={undefined}
            isCancelledStatus={undefined}
            subTitle={undefined}
            useUpdatedStyle
          />
        </Portal> : null}

      {showOrderCreatedTreat ? <Portal isInBody={false}>
          <ConfirmationPopup
            primaryBtnAction={async () => {
              const treatLink = await getTreatLink()
              window.open(treatLink, ...windowOpenArgs)
              setShowOrderCreatedTreat(false)
            }}
            title={isTreatError ? text.COULDNT_CREATE_RX : text.RX_CREATED_IN_TREAT}
            msg={
              isTreatError ?
                <div>
                  <div className='product-order-popup-text' style={{ color: '#cb4d25' }}>
                    {treatErrorMessage}
                  </div>
                  {text.COULDNT_CREATE_RX_MESSAGE}
                </div>
              : text.RX_CREATED_IN_TREAT_MESSAGE
            }
            primaryBtnText={text.CONTINUE_TO_TREAT}
            primaryImage={newScreenIcon}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            primaryImageAlt='Open treat in new tab'
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            primaryImgClassName='product-order-confirmation-popup-button-image'
            closeAction={() => {
              setShowOrderCreatedTreat(false)
            }}
            additionalContainerClass='product-order-popup-container'
            secondaryBtnText={isTreatError ? text.CANCEL : text.AUTHORIZE_LATER}
            secondaryBtnAction={() => {
              setShowOrderCreatedTreat(false)
            }}
            popUpBoxStyle={{ height: 'unset', marginTop: 0, padding: 64, maxWidth: 589 }}
            renderBody={undefined}
            id={undefined}
            isCancelledStatus
            subTitle={undefined}
            useUpdatedStyle
          />
        </Portal> : null}
    </>
  )
}
